import { baseGatewayApiV1 } from '@verantos-dev/app-state-base';
import { ListResponse, ObjectResponse } from '@verantos-dev/types-common';

import { USERS_API_PATH } from './constants';
import type {
  UserLegacyCRUDResponse,
  UserInfo,
  CreateUserRequest,
  UpdateUserRequest,
} from './types';

export const usersApiSlice = baseGatewayApiV1
  .enhanceEndpoints({
    addTagTypes: ['users'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getUsers: builder.query<ListResponse<UserInfo>, string | null>({
        query: (urlParams: string) => {
          const params = urlParams ? `${encodeURI(urlParams)}` : '';
          return `/${USERS_API_PATH}/users${params}`;
        },
        providesTags: ['users'],
      }),

      getUser: builder.query<ObjectResponse<UserInfo>, string>({
        query: (id: string) => `/${USERS_API_PATH}/users/${id}`,
      }),

      createUser: builder.mutation<ObjectResponse<UserInfo>, CreateUserRequest>({
        query: (data) => ({
          url: `/${USERS_API_PATH}/users`,
          method: 'POST',
          body: { ...data, connection: 'verantos-users-connection' },
        }),
        invalidatesTags: ['users'],
      }),

      updateUser: builder.mutation<UserLegacyCRUDResponse, UpdateUserRequest>({
        query: ({ userId, data }) => ({
          url: `/${USERS_API_PATH}/users/${userId}`,
          method: 'PUT',
          body: data,
        }),
        invalidatesTags: ['users'],
      }),
    }),
  });

export const { useGetUsersQuery, useGetUserQuery, useCreateUserMutation, useUpdateUserMutation } =
  usersApiSlice;
